// extracted by mini-css-extract-plugin
export var cartContainer = "_kf-4";
export var gray = "_kf-1";
export var itemContainer = "_kf-2";
export var itemDetails = "_kf-3";
export var strong = "_kf-0";